import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  const linkClass = scrolled
    ? 'text-foreground-700 hover:text-primary-600'
    : 'text-white/90 hover:text-white';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <button
            onClick={() => scrollTo('hero')}
            className="font-heading text-xl md:text-2xl font-semibold tracking-tight cursor-pointer"
            style={{ color: scrolled ? 'oklch(var(--foreground-950))' : 'white' }}
          >
            Haus Dornumersiel
          </button>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollTo('about')} className={`text-sm font-medium cursor-pointer whitespace-nowrap transition-colors ${linkClass}`}>
              {t('nav.about')}
            </button>
            <button onClick={() => scrollTo('gallery')} className={`text-sm font-medium cursor-pointer whitespace-nowrap transition-colors ${linkClass}`}>
              {t('nav.gallery')}
            </button>
            <button onClick={() => scrollTo('booking')} className={`text-sm font-medium cursor-pointer whitespace-nowrap transition-colors ${linkClass}`}>
              {t('nav.booking')}
            </button>
            <button onClick={() => scrollTo('contact')} className={`text-sm font-medium cursor-pointer whitespace-nowrap transition-colors ${linkClass}`}>
              {t('nav.contact')}
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i
              className={`ri-menu-3-line text-2xl ${scrolled ? 'text-foreground-950' : 'text-white'}`}
            />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            <button onClick={() => scrollTo('about')} className="text-left text-foreground-700 text-sm font-medium py-2 cursor-pointer">
              {t('nav.about')}
            </button>
            <button onClick={() => scrollTo('gallery')} className="text-left text-foreground-700 text-sm font-medium py-2 cursor-pointer">
              {t('nav.gallery')}
            </button>
            <button onClick={() => scrollTo('booking')} className="text-left text-foreground-700 text-sm font-medium py-2 cursor-pointer">
              {t('nav.booking')}
            </button>
            <button onClick={() => scrollTo('contact')} className="text-left text-foreground-700 text-sm font-medium py-2 cursor-pointer">
              {t('nav.contact')}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}